import "./FreelanceSeoConsultant.module.css";
import Header from "@/reusable_sections/Header";
import Footer from "@/reusable_sections/Footer";
import Hero from "./sections/Hero";
import WhyHire from "./sections/WhyHire";
import Comparison from "./sections/Comparison";
import Services from "./sections/Services";
import WhoIWorkWith from "./sections/WhoIWorkWith";
import Approach from "./sections/Approach";
import Process from "./sections/Process";
import WorkDirectly from "./sections/WorkDirectly";
import ConsultancyOptions from "./sections/ConsultancyOptions";
import RemoteWorking from "./sections/RemoteWorking";
import BeforeYouHire from "./sections/BeforeYouHire";
import Faq from "./sections/Faq";
import FinalCta from "./sections/FinalCta";
export default function FreelanceSeoConsultantPage() {
  return <div className="min-h-screen bg-background text-foreground">
      <Header />
      <main id="main-content">
        <Hero />
        <WhyHire />
        <Comparison />
        <Services />
        <WhoIWorkWith />
        <Approach />
        <Process />
        <WorkDirectly />
        <ConsultancyOptions />
        <RemoteWorking />
        <BeforeYouHire />
        <Faq />
        <FinalCta />
      </main>
      <Footer />
    </div>;
}